export const addConsumer = (consumer, peerId) =>
({
	type: 'ADD_CONSUMER',
	payload: { consumer, consumerId: consumer.id, peerId }
});

export const removeConsumer = (consumerId, peerId) =>
({
	type: 'REMOVE_CONSUMER',
	payload: { consumerId, peerId }
});

export const clearConsumers = () =>
({
	type: 'CLEAR_CONSUMERS'
});

export const setConsumerPaused = (consumerId, originator) =>
({
	type: 'SET_CONSUMER_PAUSED',
	payload: { consumerId, originator }
});

export const setConsumerPeerIdQlevel = (consumerId, peerId, qlevel) =>
({
	type: 'SET_CONSUMER_PEER_ID_QLEVEL',
	payload: { consumerId, peerId, qlevel }
});

export const setConsumerResumed = (consumerId, originator) =>
({
	type: 'SET_CONSUMER_RESUMED',
	payload: { consumerId, originator }
});

export const setConsumerCurrentLayers = (consumerId, spatialLayer, temporalLayer) =>
({
	type: 'SET_CONSUMER_CURRENT_LAYERS',
	payload: { consumerId, spatialLayer, temporalLayer }
});

export const setConsumerPreferedLayers = (consumerId, spatialLayer, temporalLayer) =>
({
	type: 'SET_CONSUMER_PREFERED_LAYERS',
	payload: { consumerId, spatialLayer, temporalLayer }
});

export const setConsumerPriority = (consumerId, priority) =>
({
	type: 'SET_CONSUMER_PRIORITY',
	payload: { consumerId, priority }
});

export const setConsumerTrack = (consumerId, track) =>
({
	type: 'SET_CONSUMER_TRACK',
	payload: { consumerId, track }
});

export const setConsumerScore = (consumerId, score) =>
({
	type: 'SET_CONSUMER_SCORE',
	payload: { consumerId, score }
});